<script type="application/ld+json">
	{     
		"@context": "http://schema.org",
		"@type": "BreadcrumbList",
		"itemListElement": [
		{
		  "@type": "ListItem",
		  "position": 1,
		  "item": {
		    "@id": "https://www.protectt.ai/",
		    "name": "Home"
		  }
		},{
		  "@type": "ListItem",
		  "position": 2,
		  "item": {
		    "@id": "https://www.protectt.ai/press-release",
		    "name": "Press Release"
		  }
		}		]
	}
	</script>
<!-- Breadcrumbs -->
<div class="breadcrumbs">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <ul class="breadcrumbsul">
          <li><a href="#">Home</a></li>
          <li>></li>
          <li>Press Release</li>
        </ul>
      </div>
    </div>
  </div>
</div>

<div class="section-agency-benefit bg-gray">
  <div class="container">
    <div class="row">
      <div class="col-md-12 text-center section-title mt-30">
        <h4>Protectt.ai's Mobile App Security Platform “AppProtectt” Recognized as winner of Banking Frontier Technoviti
          Award, 2023</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-xs-12 text-center mt-2">
        <img class="w-100" src="../../../assets/images/pressrelease/award-stage.webp" alt="Press Release Image">
      </div>
      <div class="col-md-6 col-xs-12 text-center mt-2">
        <img class="w-100" src="../../../assets/images/pressrelease/award-image.webp" alt="Press Release Image">
      </div>
    </div>
    <div class="row align-items-center">
      <div class="col-lg-12">
        <div class="agency-benefits">
          <div class="content mb-50">
            <p>
              <strong>Mumbai, 25<sup>th</sup> April 2023:</strong>&nbsp;<span style="color: #163e6f;">Protectt.</span><span
                style="color: #da2b27;">ai</span>, a leading Mobile Threat Defence &
              cybersecurity company, is proud to announce that its flagship Mobile App Security platform
              <strong>“AppProtectt”</strong>
              has been chosen as winner of Technoviti Award, 2023. This recognition highlights the company's
              commitment to developing innovative mobile app & device security solutions that provides maximum
              protection to businesses by controlling threats and Frauds to Mobile Apps
            </p>
            <p>
              AppProtectt is a cutting-edge security solution that uses Deep Tech powered by Cloud & Machine
              Learning to protect mobile applications from advanced cyber threats and frauds.
            </p>
            <p>
              <strong>Commenting on this win, Manish Mimani, CEO and Founder, <span
                  style="color: #163e6f;">Protectt.</span><span style="color: #da2b27;">ai</span></strong> said, <em>“We
                are honored to be recognized by Technoviti 2023 as one of the innovative products providing advance
                mobile app security platform to industry. This recognition is a testament to our team's hard work
                and dedication to developing the best security solutions focussed on emerging Mobile Threats &
                Frauds.”</em>
            </p>
            <p>
              <em>Our team at <span style="color: #163e6f;">Protectt.</span><span style="color: #da2b27;">ai</span> has
                always believed that innovation is the key to providing the best Mobile
                App security solutions to our customers. We are committed to continuing to innovate and develop
                solutions that provide the highest level of protection to businesses, mobile banking apps and
                individuals alike,”</em> <strong>said Pankaj Patankar, Head of Marketing, <span
                  style="color: #163e6f;">Protectt.</span><span style="color: #da2b27;">ai</span></strong>
            </p>
            <p>
              Technoviti is an annual event that brings together the best and brightest in the fintech and
              technology industries. The event is known for recognizing the most innovative products and
              solutions that have the potential to transform the industry. <span
                style="color: #163e6f;">Protectt.</span><span style="color: #da2b27;">ai</span>'s AppProtectt was chosen
              for
              its innovative approach to mobile application security and its ability to protect against emerging
              cyber threats. With cyber threats on the rise, it is more important than ever for businesses and
              individuals to take steps to protect their sensitive information.
            </p>
            <p><strong>For media queries, please contact:</strong></p>
            <p>
              Kalpesh Jagtap – <a href="mailto:kalpesh.j@protectt.ai">kalpesh.j@protectt.ai</a><br>
              Pankaj Patankar – <a href="mailto:pankaj.p@protectt.ai">pankaj.p@protectt.ai</a><br>
            </p>
          </div>
        </div>
      </div>
      <!-- <div class="col-lg-6 order-md-first">
        <div class="agency-thumb">
          <div class="thumb">
            <img src="assets/images/cyber-lab-services/assessment_services.webp"
              alt="Implement Cyber Security Consultants for your Business" />
          </div>
        </div>
      </div> -->
    </div>
  </div>
</div>
<!-- End Info Area -->